import { createGlobalStyle } from 'styled-components';
import reboot from 'styled-reboot';

export const GlobalStyles = createGlobalStyle`
  ${reboot};
`;
